import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ParametresInstance } from "../Controls/Parameters";
import { SalarieContratDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieContratDto";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as ContratTypeComponent);
			vm.Init();
		});
	}
})
export default class ContratTypeComponent extends Vue {
	public isModified = false;
	public dataReady = false;

	public contratType: SalarieContratDto = {
    	IdSalarie: 0,
    	NumeroSalarie: 0,
        SalairePerso: false,
        EstNotaireSalarie: false,
    	TicketsRestaurant: false,
    	FraisProfessionnels: false,
		TreiziemeMois: false,
		EstTreiziemeMoisMensualise: false,
        ExonerationCsg: false,
        CsgCrdsApprenti: false,
    	AvantageEnNature: false,
    	CongesDixieme: false,
    	ContratActif: false,
    	RubriqueContrats: [],
    	IsCurrent: true
	};

	public listeConventionsCollectives: ParametreDto[] = [];
	public listeCodesClassification: ParametreDto[] = [];
	public listeNatureContrats: ParametreDto[] = [];
	public listeTypeContrats: ParametreDto[] = [];
	public listeRemunerations: ParametreDto[] = [];
	public listeMaladieRetraites: ParametreDto[] = [];
	public listeCaisseComplementaires: ParametreDto[] = [];
	public listeGestionConges: ParametreDto[] = [];

	public Init(): void {
    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
    		ServicesFactoryInstance.SalarieService.getSalarieContratType((data) => {
    			this.contratType = data;
    			this.isModified = false;
    			this.dataReady = true;
    		});
    		this.setData();
    	}
	}

	public setData(): void {
    	ServicesFactoryInstance.ParametresService.getConventionsCollectives(data => {
    		this.listeConventionsCollectives = data;
    	});
    	ServicesFactoryInstance.ParametresService.getClassifications(false, data => {
    		this.listeCodesClassification = data;
    	});

    	ServicesFactoryInstance.ParametresService.getNatureContrats(data => {
    		this.listeNatureContrats = data;
    	});
    	ServicesFactoryInstance.ParametresService.getTypeContrats(data => {
    		this.listeTypeContrats = data;
    	});
    	ServicesFactoryInstance.ParametresService.getRemunerations(data => {
    		this.listeRemunerations = data;
    	});
    	ServicesFactoryInstance.ParametresService.getMaladieRetraites(data => {
    		this.listeMaladieRetraites = data;
    	});
    	ServicesFactoryInstance.ParametresService.getCaisseComplementaires(data => {
    		this.listeCaisseComplementaires = data;
    	});
    	ServicesFactoryInstance.ParametresService.getGestionConges(data => {
    		this.listeGestionConges = data;
    	});
	}

	public champModified(): void {
    	this.isModified = true;
	}

	public annuler(): void {
    	this.Init();
	}

	public update(): void {
    	ServicesFactoryInstance.SalarieService.updateUpdateContratType(this.contratType, (data) => {
    		this.contratType = data;
    		this.Init();
    		ParametresInstance.refreshAllList();
    		NotificationServiceInstance.SendSuccess("Le contrat type a bien été modifié.");
    	});
	}
}



// WEBPACK FOOTER //
// ./src/components/contratType/contratType.ts